<template>
    <v-card>
        <!-- <v-menu
            v-model="showStatusMenu"
            :position-x="statusMenuPosition.x"
            :position-y="statusMenuPosition.y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item
                    v-for="(option, index) in projectStatuses"
                    :key="index"
                    :class="option.status_menu_color"
                    ripple
                    @click="$emit('changeStatus', selectedStatusItem, option.value)"
                >
                    <v-list-item-title
                        :style="`color: ${['closed','cloned'].includes(option.value) ? 'lightgray' : 'inherit'}; cursor:pointer;`"
                    >
                        {{ option.internal_label }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> -->

		<v-card-text class="">
            <table class="table">
                <tr>
                    <td class="text-left">{{ resolutionData.date_initialized ? resolutionData.date_initialized.substr(0, 10) : 'N/A' }}</td>
                    <td class="text-left">
                        <div class="d-flex align-center">
                            <div class="d-inline font-weight-bold" 
                                :class="getStatusMetaData(resolutionData.status) ? getStatusMetaData(resolutionData.status).status_text_color : ''"
                                style="width: 50%">
                                {{ getStatusMetaData(resolutionData.status) ? getStatusMetaData(resolutionData.status).internal_label : 'N/A' }}
                            </div>

                            <div class="d-inline" style="width: 50%">
                                <v-btn
                                    v-if="resolutionData.status != 'complete'"
                                    x-small
                                    class="mx-2 elevation-1"
                                    fab
                                    color="primary darken-1"
                                    @click.stop="$emit('openStatusMenu', $event, resolutionData)">
                                    <v-icon>mdi-palette-swatch-variant</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </td>

                    <td class="text-left">
                        {{ resolutionData.date_submitted ? resolutionData.date_submitted.substr(0, 10) : 'N/A' }}
                    </td>
                    <td class="text-center">
                        {{ $emit('getResolutionCount', resolutionData.resolutions_data) ? $emit('getResolutionCount', resolutionData.resolutions_data) : '0' }}
                    </td>

                    <td class="text-right">
                        {{ resolutionData.close_date ? resolutionData.status != 'complete' ? 'est. ' + resolutionData.close_date.substr(0, 10) : resolutionData.close_date.substr(0, 10) : 'N/A' }}
                    </td>
                    
                    <td class="text-right">
                        <div v-for="doc in projectDetails.dlvs.filter(file => file.question === resolutionData.project_id)" 
							:key="doc.file_id" 
							class="pb-1 d-block">
                            <a :href="doc.url" target="_blank">{{ doc.file_name }}</a>
                        </div>
                    </td>

                    <td class="text-right">
                        <v-icon
							fab
                            color="grey"
                            @click.stop.prevent="$emit('uploadResolutionDeliverables', resolutionData)">
                            mdi-cloud-upload
                        </v-icon>
                        
                        <v-icon
                            v-if="resolutionData.has_data"
							fab
                            color="grey"
                            @click.stop.prevent="$emit('buyerQuestionnaire', resolutionData)">
                            mdi-eye
                        </v-icon>

                        <v-icon 
                            v-if="resolutionData.has_data" 
							fab
                            color="grey" 
                            @click.stop.prevent="$emit('exportAnswers', resolutionData)">
                            mdi-export
                        </v-icon>
                        <div v-else>
                            No Data
                        </div>
                    </td>
                </tr>        
            </table>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="d-flex justify-end mt-3 mx-2">
            Actions Here
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    export default {
        name: 'ResolutionSubmission',
        
        props: {
            resolutionData: Object,
            projectData: Object,
            moduleKey: String,
            resolutionId: String,
            parentProjectId: String,
            userId: String,
            projectStatuses: Array,
            calculateResolutionsUsed: Number,
            closeNavigationDrawer: Function,
            closeUploadDeliverables: Function,
            changeStatus: Function,
            updateResolutionStatus: Function,
            getResolutionCount: Function,
            uploadResolutionDeliverables: Function,
            exportAnswers: Function,
            buyerQuestionnaire: Function,
            closeQuestionnaire: Function,
            triggerUserFeedback: Function
        },
        
        data() {
            return {
                showStatusMenu: false,
                statusMenuPosition: { x: 0, y: 0 },
            }
        },

        mounted: function () {
            console.log(this.resolutionData);
        },

        methods: {
            openStatusMenu ( event, item ) {
                this.selectedStatusItem = item
                this.statusMenuPosition.x = event.clientX
                this.statusMenuPosition.y = event.clientY
                this.showStatusMenu = true
            },

            getStatusMetaData: function ( status_val ) {
                return this.projectStatuses.find( status => status.value == status_val ) ? this.projectStatuses.find( status => status.value == status_val ) : {}
            },
        }
    }
</script>

<style scoped>
    .required_rule >>> .v-messages__message {
        color:red;
    }
</style>


// WEBPACK FOOTER //
// src/components/ResolutionSubmission.vue